import {A360Plan} from 'Quoting/models/Quoting';

// Proposal generation supported states for individual plans
const GAI7: readonly string[] = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'DE',
  'FL',
  'GA',
  'GU',
  'HI',
  'IL',
  'IA',
  'LA',
  'MA',
  'MS',
  'MO',
  'NV',
  'NC',
  'OK',
  'PA',
  'SC',
  'SD',
  'TX',
  'WV',
  'WI',
  'WY',
  'CA',
  'NJ',
  'NE',
  'MI',
  'TN',
  'VA',
  'CT',
  'ID',
  'ME',
  'MT',
  'ND',
  'NH',
  'OR',
  'PR',
  'UT',
  'VI',
  'VT',
  'OH',
  'KS',
  'KY',
];

const GVA6: readonly string[] = ['CO', 'DC', 'IN', 'KS', 'KY', 'MD', 'MN', 'OH', 'RI', 'WA'];

const GCI5: readonly string[] = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CT',
  'DE',
  'DC',
  'FL',
  'GA',
  'GU',
  'HI',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'NE',
  'NV',
  'NH',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'SC',
  'SD',
  'TX',
  'UT',
  'VT',
  'VA',
  'WV',
  'WI',
  'WY',
  'ID',
  'MD',
  'TN',
  'CA',
  'MT',
  'PR',
  'RI',
  'VI',
];

const GVCI4: readonly string[] = ['CO', 'NJ'];

const GIM2: readonly string[] = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'DC',
  'GA',
  'GU',
  'HI',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'MD',
  'MA',
  'ME',
  'MN',
  'MS',
  'MO',
  'NE',
  'NH',
  'NJ',
  'NV',
  'NC',
  'OH',
  'OK',
  'OR',
  'PA',
  'PR',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'VA',
  'VI',
  'UT',
  'WV',
  'WI',
  'ID',
  'FL',
  'MI',
  'ND',
];

const GHI3: readonly string[] = [
  'AL',
  'AK',
  'AR',
  'DE',
  'FL',
  'GA',
  'HI',
  'IA',
  'IL',
  'KS',
  'KY',
  'LA',
  'MA',
  'ME',
  'MS',
  'MO',
  'NE',
  'NV',
  'OK',
  'PA',
  'SC',
  'SD',
  'TX',
  'WV',
  'WI',
  'WY',
  'CT',
  'DC',
  'GU',
  'IN',
  'MI',
  'MN',
  'NC',
  'ND',
  'NJ',
  'OH',
  'RI',
  'TN',
  'VI',
  'VT',
  'ID',
  'CO',
  'VA',
];

// Plan1 = GWL = GPLU
const Plan1: readonly string[] = [
  'AL',
  'AK',
  'AS',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'DC',
  'FL',
  'GA',
  'GU',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'MP',
  'OH',
  'OK',
  'OR',
  'PA',
  'PR',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
  'VI',
];

export const getProposalGenerationSupportedStates = (planCode: A360Plan): readonly string[] => {
  switch (planCode) {
    case A360Plan.GAI7:
      return GAI7;
    case A360Plan.GVA6:
      return GVA6;
    case A360Plan.GCI5:
      return GCI5;
    case A360Plan.GVCI4:
      return GVCI4;
    case A360Plan.GHI3:
      return GHI3;
    case A360Plan.GIM2:
      return GIM2;
    case A360Plan.GPLU:
      return Plan1;
    default:
      return [];
  }
};
